import {
    OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_EN_CURS,
    OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_FINALITZAT,
    OBSERVACIO_EXPORTACIO_INICIALITZAR
} from '../../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioObservacionsEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case OBSERVACIO_EXPORTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_EN_CURS:
            return true;

        case OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_FINALITZAT:
            return false;

        default:
            return state;
    }
};

export default peticioObservacionsEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/observacio/exportacio/peticioObservacionsEnCurs.js